<script>
export default {
    props: {
        defaultKillerQuestionSpecs: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        },
    },

    data() {
        return {
            killerQuestionSpecs: [...this.defaultKillerQuestionSpecs]
        }
    },

    methods: {
        addKillerQuestionSpec() {
            this.killerQuestionSpecs.push({
                title: '',
                killer_question_answers: []
            })
        },
        removeKillerQuestionSpec(index) {
            this.killerQuestionSpecs.splice(index, 1)
        },
        addKillerQuestionSpecAnswer(index) {
            if (this.killerQuestionSpecs[index].killer_question_answers == undefined) {
                this.killerQuestionSpecs[index].killer_question_answers = []
            }

            this.killerQuestionSpecs[index].killer_question_answers.push({
                title: '',
                is_correct: false,
            })
        },
        removeAnswer(qIndex, aIndex) {
            this.killerQuestionSpecs[qIndex].killer_question_answers.splice(aIndex, 1)
        }
    }
}
</script>

<template>
    <div class="killer-question-specs">
        <div>
            <fieldset v-for="(killerQuestionSpec, i) in killerQuestionSpecs" :key="i">
                <input v-if="killerQuestionSpec.id" :name="`killer_questions[${i}][id]`" type="hidden" required :value="killerQuestionSpec.id" />

                <div class="grid-x grid-padding-x mb-2">
                    <div class="cell pl-10 ml-6 pr-0 small-12">
                        <label>Question(s)</label>

                        <div class="grid-x grid-padding-x">
                            <div class="cell auto pr-0">
                                <input :disabled="disabled" :name="`killer_questions[${i}][title]`" type="text" required v-model="killerQuestionSpec.title" />
                            </div>

                            <div class="cell shrink">
                                <div v-if="!disabled" @click="() => removeKillerQuestionSpec(i)" class="remove-button"><i class="fas fa-minus-circle"></i></div>
                            </div>
                        </div>
                    </div>

                    <div class="cell pl-30 pr-0 small-6">
                        <label>Answer(s):</label>
                    </div>

                    <div class="cell pl-5 pr-0 small-6">
                        <label>Result:</label>
                    </div>
                </div>

                <div v-for="(answer, j) in killerQuestionSpec.killer_question_answers" :key="j" class="grid-x grid-padding-x">
                    <input v-if="answer.id" :name="`killer_questions[${i}][killer_question_answers][${j}][id]`" type="hidden" required :value="answer.id" />

                    <div class="cell pl-30 pr-0 small-6">
                        <input :disabled="disabled" :name="`killer_questions[${i}][killer_question_answers][${j}][title]`" type="text" maxlength="50" required v-model="answer.title" />
                    </div>

                    <div class="cell pl-5 pr-0 auto">
                        <select :disabled="disabled" :name="`killer_questions[${i}][killer_question_answers][${j}][is_correct]`" required v-model="answer.is_correct">
                            <option :value="false">Fail</option>
                            <option :value="true">Pass</option>
                        </select>
                    </div>

                    <div class="cell shrink">
                        <div v-if="!disabled" @click="() => removeAnswer(i, j)" class="remove-button"><i class="fas fa-minus-circle"></i></div>
                    </div>
                </div>
                <input v-if="killerQuestionSpec.killer_question_answers.length == 0" :disabled="disabled" :name="`killer_questions[${i}][killer_question_answers]`" value="" type="hidden" />

                <div v-if="!disabled" @click="addKillerQuestionSpecAnswer(i)" class="add-button ml-20"><i class="fas fa-plus-circle"></i></div>
            </fieldset>

            <div v-if="!disabled" @click="addKillerQuestionSpec" class="add-button"><i class="fas fa-plus-circle"></i></div>

            <input v-if="killerQuestionSpecs.length === 0" name="killer_questions" value="" type="hidden" />
        </div>
    </div>
</template>